document.addEventListener("DOMContentLoaded", function () {
    const mystery_box_product = document.querySelector(".mystery__box-product");
    const mystery_box_properties = document.querySelector(".mystery__box-properties");
    const topsInputs = document.querySelectorAll("#tops-options input");
    const bottomsInputs = document.querySelectorAll("#bottoms-options input");

    function updateMysteryBox(value) {
        if (value === "Oberteile") {
            mystery_box_product.classList.add("myster_box_oberteile");
            mystery_box_product.classList.remove("myster_box_unterteile");
            mystery_box_properties.classList.add("active");
            topsInputs.forEach(i => i.disabled = false);
            bottomsInputs.forEach(i => i.disabled = true);
        } else if (value === "Unterteile") {
            mystery_box_product.classList.add("myster_box_unterteile");
            mystery_box_product.classList.remove("myster_box_oberteile");
            mystery_box_properties.classList.remove("active");
            topsInputs.forEach(i => i.disabled = true);
            bottomsInputs.forEach(i => i.disabled = false);
        }
    }

    // ---------------------------------------
    // ONLOAD CHECK
    // ---------------------------------------
    const checkedInput = document.querySelector(".product-form__input.product-form__input--pill input:checked");
    if (checkedInput) {
        updateMysteryBox(checkedInput.value);
    }

    // ---------------------------------------
    // CHANGE LISTENER
    // ---------------------------------------
    document.body.addEventListener("change", function (e) {
        if (e.target.matches(".product-form__input.product-form__input--pill input")) {
            updateMysteryBox(e.target.value);
        }
    });
});
